import React from 'react';
import MobileNav from '../../component/MobileNav';
import cibilMeter from '../../assets/civil-meter.svg';
import { useSelector } from 'react-redux';
import VerifiedIcon from '@mui/icons-material/Verified';

export default function UserProfile() {
    const customerDetails = useSelector(
        (state) => state?.customerJourneyDetails?.customerDetails
    );

    const formattedDOB = customerDetails?.dob
        ? new Date(customerDetails.dob).toLocaleDateString('en-GB')
        : '-';

    const getMaritalStatus = (id) => {
        switch (Number(id)) {
            case 1:
                return 'Single';
            case 2:
                return 'Married';
            default:
                return '-';
        }
    };

    const styles = {
        page: {
            background: '#f5f7fb',
            minHeight: '100vh',
            padding: '20px 10px',
        },
        card: {
            background: '#fff',
            borderRadius: '14px',
            boxShadow: '0 8px 25px rgba(0,0,0,0.06)',
            padding: '18px',
        },
        header: {
            background: '#0f1c2e',
            color: '#fff',
            borderRadius: '14px',
            padding: '20px',
        },
        accent: {
            color: '#ff7a00',
        },
        badge: {
            background: '#0f1c2e',
            color: '#fff',
            padding: '4px 10px',
            borderRadius: '20px',
            fontSize: '12px',
        },
        tableLabel: {
            color: '#0f1c2e',
            fontWeight: 600,
        },
    };

    return (
        <>
            <div style={styles.page}>
                <div className="container" style={{marginTop:"90px"}}>

                    {/* HEADER */}
                    <div style={styles.header} className="mb-3">
                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">

                            <div className="d-flex align-items-center gap-3">
                                <div
                                    style={{
                                        width: 60,
                                        height: 60,
                                        borderRadius: '50%',
                                        background: '#fff',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        overflow: 'hidden',
                                    }}
                                >
                                    {customerDetails?.profile_pic ? (
                                        <img
                                            src={customerDetails.profile_pic}
                                            alt="profile"
                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                        />
                                    ) : (
                                        <span style={{ color: '#0f1c2e' }}>👤</span>
                                    )}
                                </div>

                                <div>
                                    <h4 className="mb-0">
                                        Welcome <b>{customerDetails?.full_name}</b>
                                    </h4>

                                    <div className="d-flex align-items-center gap-2 mt-1">
                                        <span style={styles.badge}>
                                            Verified <VerifiedIcon style={{ fontSize: 16, color: '#00c853' }} />
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="text-md-end">
                                <div className="small opacity-75">Application Status</div>
                                <div
                                    style={{
                                        background: '#ff7a00',
                                        color: '#fff',
                                        padding: '6px 10px',
                                        borderRadius: '8px',
                                        fontWeight: 600,
                                        display: 'inline-block',
                                        marginTop: 4,
                                    }}
                                >
                                    {customerDetails?.applicationStatus || 'Pending'}
                                </div>

                                <div className="small mt-2 opacity-75">Application No.</div>
                                <div style={{ color: '#ff7a00', fontWeight: 700 }}>
                                    {customerDetails?.leadReferenceNo}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* CIBIL CARD */}
                    <div style={styles.card} className="mb-3 text-center">
                        <img src={cibilMeter} alt="cibil" style={{ width: 90 }} />
                        <h3 style={{ color: '#0f1c2e', marginTop: 10 }}>
                            {customerDetails?.cp_bureau_score || '-'}
                        </h3>
                        <p className="mb-0 small text-muted">
                            Credit score based on your loan activity
                        </p>
                    </div>

                    {/* DETAILS GRID */}
                    <div style={styles.card}>
                        <div className="row g-3">

                            <div className="col-12 col-md-6">
                                <div><span style={styles.tableLabel}>PAN Number:</span></div>
                                <div>{customerDetails?.pancard || '-'}</div>
                            </div>

                            <div className="col-12 col-md-6">
                                <div><span style={styles.tableLabel}>Date of Birth:</span></div>
                                <div>{formattedDOB}</div>
                            </div>

                            <div className="col-12 col-md-6">
                                <div><span style={styles.tableLabel}>Marital Status:</span></div>
                                <div>{getMaritalStatus(customerDetails?.marital_status_id)}</div>
                            </div>

                            <div className="col-12 col-md-6">
                                <div><span style={styles.tableLabel}>Pincode:</span></div>
                                <div>{customerDetails?.residence_pincode || '-'}</div>
                            </div>

                            <div className="col-12 col-md-6">
                                <div><span style={styles.tableLabel}>Contact:</span></div>
                                <div>{customerDetails?.mobile || '-'}</div>
                            </div>

                            <div className="col-12 col-md-6">
                                <div><span style={styles.tableLabel}>Monthly Income:</span></div>
                                <div>{customerDetails?.monthly_income || '-'}</div>
                            </div>

                            <div className="col-12 col-md-6">
                                <div><span style={styles.tableLabel}>Personal Email:</span></div>
                                <div style={{ wordBreak: 'break-word' }}>
                                    {customerDetails?.personal_email?.toLowerCase?.() || '-'}
                                </div>
                            </div>

                            <div className="col-12 col-md-6">
                                <div><span style={styles.tableLabel}>Official Email:</span></div>
                                <div style={{ wordBreak: 'break-word' }}>
                                    {customerDetails?.office_email || '-'}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <MobileNav />
        </>
    );
}